import {createContext} from 'react';
import {PopupData} from '../Components/Block/AbroadCellularPackagesItemsBlock';

export const PopupContext = createContext<{
  setPopUpData: (data: PopupData | null) => void;
}>(null);
